import androidHero from "../../images/hireteam/android-developer-hero.webp";
import angularJSHero from "../../images/hireteam/angularjs-hero.webp";
import aspNetHero from "../../images/hireteam/asp.net-developer-hero.webp";
import awsCloudHero from "../../images/hireteam/awscloud-developer-hero.webp";
import azureCloudHero from "../../images/hireteam/azurecloud-developer-hero.webp";
import blockchainHero from "../../images/hireteam/blockchain-developer-hero.webp";
import devopsHero from "../../images/hireteam/devops-engineer-hero.webp";
import flutterHero from "../../images/hireteam/flutter-developer-hero.webp";
import fullstackJavaHero from "../../images/hireteam/fullstack-lava-developer-hero.webp";
import fullstackPythonHero from "../../images/hireteam/fullstack-python-developer-hero.webp";
import gcpCloudHero from "../../images/hireteam/gcpcloud-developer-hero.webp";
import golangHero from "../../images/hireteam/golang-hero.webp";
import ionicHero from "../../images/hireteam/ionic-developer-hero.webp";
import iosHero from "../../images/hireteam/ios-developer-hero.webp";
import machineLearningHero from "../../images/hireteam/machinelearning-engineer-hero.webp";
import manualQAHero from "../../images/hireteam/manualqa-engineer-hero.webp";
import mernStackHero from "../../images/hireteam/mern-stack-developer-hero.webp";
import meanStackHero from "../../images/hireteam/mean-stack-developer-hero.webp";
import moodleHero from "../../images/hireteam/moodle-developer-hero.webp";
import nodejsHero from "../../images/hireteam/nodejs-hero.webp";
import phpHero from "../../images/hireteam/php-developer-hero.webp";
import powerbiHero from "../../images/hireteam/powerbi-developer-hero.webp";
import reactJSHero from "../../images/hireteam/reactjs-hero.webp";
import reactNativeHero from "../../images/hireteam/reactnative-developer-hero.webp";
import rpaHero from "../../images/hireteam/rpa-developer-hero.webp";
import uiuxHero from "../../images/hireteam/uiux-developer-hero.webp";
import vuejsHero from "../../images/hireteam/vuejs-hero.webp";
import wordpressHero from "../../images/hireteam/wordpress-developer-hero.webp";
import xamarinHero from "../../images/hireteam/xamarin-developer-hero.webp";
import securityTestEngineerHero from "../../images/hireteam/security-test-engineer-hero.webp";
import automationTestEngineerHero from "../../images/hireteam/automationtest-engineer-hero.webp";

import androidList from "../../images/hireteam/hire-product/android-list.webp";
import angularJSList from "../../images/hireteam/hire-product/angular-list.webp";
import aspNetList from "../../images/hireteam/hire-product/aspnet-list.webp";
import awsCloudList from "../../images/hireteam/hire-product/aws-list.webp";
import azureCloudList from "../../images/hireteam/hire-product/azure-list.webp";
import blockchainList from "../../images/hireteam/hire-product/blockchain-list.webp";
import devopsList from "../../images/hireteam/hire-product/devops-list.webp";
import flutterList from "../../images/hireteam/hire-product/flutter-list.webp";
import gcpCloudList from "../../images/hireteam/hire-product/gcp-list.webp";
import golangList from "../../images/hireteam/hire-product/golang-list.webp";
import ionicList from "../../images/hireteam/hire-product/ionic-list.webp";
import iosList from "../../images/hireteam/hire-product/ios-list.webp";
import fullstackJavaList from "../../images/hireteam/hire-product/java-list.webp";
import meanStackList from "../../images/hireteam/hire-product/meanstack-list.webp";
import mernStackList from "../../images/hireteam/hire-product/mernstack-list.webp";
import machineLearningList from "../../images/hireteam/hire-product/ml-list.webp";
import moodleList from "../../images/hireteam/hire-product/moodle-list.webp";
import nodejsList from "../../images/hireteam/hire-product/nodejs-list.webp";
import phpList from "../../images/hireteam/hire-product/php-list.webp";
import powerbiList from "../../images/hireteam/hire-product/power-bi-list.webp";
import fullstackPythonList from "../../images/hireteam/hire-product/python-list.webp";
import reactJSList from "../../images/hireteam/hire-product/reactjs-list.webp";
import reactNativeList from "../../images/hireteam/hire-product/reactnative-list.webp";
import rpaList from "../../images/hireteam/hire-product/rpa-list.webp";
import securityTestEngineerList from "../../images/hireteam/hire-product/securitytest-list.webp";
import softwareTestEngineerList from "../../images/hireteam/hire-product/software-testing-list.webp";
import uiuxList from "../../images/hireteam/hire-product/uiux-list.webp";
import vuejsList from "../../images/hireteam/hire-product/vue-list.webp";
import wordpressList from "../../images/hireteam/hire-product/wordpress-list.webp";
import xamarinList from "../../images/hireteam/hire-product/xamarin-list.webp";

export const hireTeamImages = {
  hero: {
    android: androidHero,
    angularJS: angularJSHero,
    aspNet: aspNetHero,
    awsCloud: awsCloudHero,
    azureCloud: azureCloudHero,
    blockchain: blockchainHero,
    devops: devopsHero,
    flutter: flutterHero,
    fullstackJava: fullstackJavaHero,
    fullstackPython: fullstackPythonHero,
    gcpCloud: gcpCloudHero,
    golang: golangHero,
    ionic: ionicHero,
    ios: iosHero,
    machineLearning: machineLearningHero,
    manualQA: manualQAHero,
    mernStack: mernStackHero,
    meanStack: meanStackHero,
    moodle: moodleHero,
    nodejs: nodejsHero,
    php: phpHero,
    powerbi: powerbiHero,
    reactJS: reactJSHero,
    reactNative: reactNativeHero,
    rpa: rpaHero,
    securityTestEngineer: securityTestEngineerHero,
    uiux: uiuxHero,
    vuejs: vuejsHero,
    wordpress: wordpressHero,
    xamarin: xamarinHero,
    automationTestEngineer: automationTestEngineerHero

  },
  technologyImg: {
    android: androidList,
    angularJS: angularJSList,
    aspNet: aspNetList,
    awsCloud: awsCloudList,
    azureCloud: azureCloudList,
    blockchain: blockchainList,
    devops: devopsList,
    flutter: flutterList,
    fullstackJava: fullstackJavaList,
    fullstackPython: fullstackPythonList,
    gcpCloud: gcpCloudList,
    golang: golangList,
    ionic: ionicList,
    ios: iosList,
    machineLearning: machineLearningList,
    moodle: moodleList,
    nodejs: nodejsList,
    php: phpList,
    powerbi: powerbiList,
    reactJS: reactJSList,
    reactNative: reactNativeList,
    rpa: rpaList,
    securityTestEngineer: securityTestEngineerList,
    softwareTestEngineer: softwareTestEngineerList,
    uiux: uiuxList,
    vuejs: vuejsList,
    wordpress: wordpressList,
    xamarin: xamarinList
  },
};
